<template>
  <div>
    <div class="tab-pane slide-left active">
      <div class="row column-seperation">
        <div class="col-md-12">
          <div class="title">
            <h3 v-if="brands.active.length && !editing">Marques:</h3>
            <h3 v-else-if="editing">Création d'une Marque:</h3>
            <h3 v-else>Aucune Marque</h3>
            <button class="btn btn-complete"
                    v-show="!editing"
                    @click="editing = true">Ajouter</button>
          </div>
          <div class="m-t-20">
            <item v-for="(brand, idx) in brands.active"
                  :key="'active-brand'+idx"
                  :brand="brand"
                  :is-prospect="isProspect"
                  @remove="removeBrand"
                  @archive="archiveBrand"></item>
            <new-item v-if="editing"
                      v-model="newBrand.brand.name"
                      @add="handleNewBrand"
                      @cancel="resetNewItem"></new-item>
          </div>
        </div>
        <div class="col-md-12"
             v-if="brands.old.length">
          <div class="title">
            <h3>Ancienne(s) Marque(s):</h3>
          </div>
          <div class="m-t-20">
            <item v-for="(brand, idx) in brands.old"
                  :key="'old-brand'+idx"
                  :brand="brand"></item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  
</style>

<script type="text/babel">
  import Item from './Brands/Item'
  import NewItem from './Brands/NewItem'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Brands',

    data () {
      return {
        newBrand: {
          brand: {
            name: ""
          }
        },
        editing: false
      }
    },

    components: {
      Item,
      NewItem,
    },

    computed: mapGetters('customer', {
      brands: 'filteredBrands',
      isProspect: 'isProspect',
    }),

    methods: {
      ...mapActions('customer', [
        'addBrand',
        'removeBrand',
        'archiveBrand',
      ]),

      resetNewItem () {
        this.newBrand.name = ""
        this.editing = false
      },

      handleNewBrand () {
        this.$store.commit('FORM_ERROR', {})
        this.addBrand(this.newBrand)
          .then(this.resetNewItem)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/Brands.vue